import { BadgeCheck, Clock, Coins, Send } from "lucide-react";

const replyText = (m) => {
  if (!m.replies) return "Sin respuestas todavía";
  const h = m.avg_reply_hours;
  const t = h < 24 ? `${Math.max(1, Math.round(h))} h` : `${Math.round(h / 24)} ${Math.round(h / 24) === 1 ? "día" : "días"}`;
  return `Responde en ~${t} · ${Math.round(m.reply_rate * 100)}% respondidos`;
};

export const MediaCard = ({ m, onSend }) => (
  <div data-testid={`media-card-${m.id}`} className="group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-[#12121A] transition-[border-color] hover:border-white/25">
    <div className="relative h-36 overflow-hidden">
      <img src={m.logo_url || "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&q=70"} alt={m.name} className="h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#12121A] to-transparent" />
      <span className="absolute left-3 top-3 rounded-sm bg-black/60 px-2 py-1 font-mono text-[10px] tracking-widest text-white backdrop-blur">{m.format?.toUpperCase()}</span>
      {m.verified && <span data-testid={`media-verified-${m.id}`} className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-emerald-500/90 px-2 py-1 font-mono text-[10px] tracking-wider text-white"><BadgeCheck className="h-3.5 w-3.5" />VERIFICADO</span>}
    </div>
    <div className="flex flex-1 flex-col p-5">
      <p className="font-mono text-[10px] tracking-[0.2em] text-amber-500/90">{m.country?.toUpperCase()}</p>
      <h3 className="mt-1 font-heading text-lg font-bold text-white">{m.name}</h3>
      <p className="mt-2 line-clamp-2 text-sm text-slate-400">{m.description}</p>
      {"replies" in m && <p data-testid={`media-reply-time-${m.id}`} className="mt-2 flex items-center gap-1.5 font-mono text-[11px] text-slate-500"><Clock className="h-3 w-3" />{replyText(m)}</p>}
      <div className="mt-3 flex flex-wrap gap-1.5">
        {m.genres?.map((g) => <span key={g} className="rounded-full border border-white/10 px-2 py-0.5 text-[11px] text-slate-300">{g}</span>)}
      </div>
      <div className="mt-auto flex items-center justify-between pt-5">
        <span className="flex items-center gap-1.5 font-mono text-sm text-amber-400"><Coins className="h-4 w-4" />{m.cost_credits} {m.cost_credits === 1 ? "crédito" : "créditos"}</span>
        {onSend && (
          <button data-testid={`media-send-btn-${m.id}`} onClick={() => onSend(m)} className="flex items-center gap-1.5 rounded-full bg-[#FF4500] px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#ff5a1f]">
            <Send className="h-3.5 w-3.5" /> Enviar canción
          </button>
        )}
      </div>
    </div>
  </div>
);
